import React, { SVGProps } from 'react';

import {
  FaceBook,
  Linkedin,
  SvgIconLight,
  Telegram,
  Twitter,
} from '@r-client/shared/ui/icons';

import { E_SHARE_TYPE } from '../../constants';

import styles from './share-button.module.scss';

interface IShareIconProps {
  type: E_SHARE_TYPE;
  className?: string;
}

const iconMap = {
  [E_SHARE_TYPE.FACEBOOK]: FaceBook,
  [E_SHARE_TYPE.TELEGRAM]: Telegram,
  [E_SHARE_TYPE.TWITTER]: Twitter,
  [E_SHARE_TYPE.LINKEDIN]: Linkedin,
};

const getIconByType = (
  type: E_SHARE_TYPE
): React.FC<React.PropsWithChildren<SVGProps<SVGSVGElement>>> | undefined => {
  return iconMap[type];
};

const stylesMap = {
  [E_SHARE_TYPE.FACEBOOK]: styles.brandFacebook,
  [E_SHARE_TYPE.TELEGRAM]: styles.brandTelegram,
  [E_SHARE_TYPE.TWITTER]: styles.brandTwitter,
  [E_SHARE_TYPE.LINKEDIN]: styles.brandLinkedin,
};

const getClassByType = (type: E_SHARE_TYPE): string | undefined => {
  return stylesMap[type];
};

export const ShareIcon: React.FC<React.PropsWithChildren<IShareIconProps>> = ({
  type,
}) => {
  const Component = getIconByType(type);
  const className = getClassByType(type);
  return Component ? (
    <SvgIconLight className={className} icon={Component} />
  ) : null;
};
